import { render, staticRenderFns } from "./ProductCardView.vue?vue&type=template&id=70868db7&scoped=true&"
import script from "./ProductCardView.vue?vue&type=script&lang=ts&"
export * from "./ProductCardView.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCardView.vue?vue&type=style&index=0&id=70868db7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70868db7",
  null
  
)

export default component.exports